const WARNING_TEXT = "שימו לב! לוחות הזמנים צפופים במיוחד\nהאירוע שלכם קרוב מאוד, ולכן חלק מההודעות והשיחות עשויות להישלח בהפרשי זמן קצרים או בשעות חריגות.\nמומלץ לפנות לשירות הלקוחות לפני הפעלת החבילה.";
const CUTOFF_WARNING_TEXT = "נותרה שעה או פחות עד תחילת האירוע.\nלא ניתן להפעיל את החבילה בשלב זה. אנא פנו בדחיפות לשירות הלקוחות.";
const GIFT_CUTOFF_WARNING_TEXT = "נותרה שעה או פחות עד תחילת האירוע.\nלא ניתן לתזמן את קישור המתנה באופן אוטומטי בשלב זה. אנא פנו בדחיפות לשירות הלקוחות.";
const WHATSAPP_TEXT = "החבילה שרכשתי כבר לא מתאימה ללוחות הזמנים של האירוע.";
const WHATSAPP_URL = `https://wa.me/972522295517?text=${encodeURIComponent(WHATSAPP_TEXT)}`;

const PurchasedScheduleUnavailableWarning = ({ blocking = false, gift = false }) => (
  <div className="autopilot-purchased-schedule-warning" role="alert">
    <strong style={{ whiteSpace: "pre-line" }}>{blocking ? (gift ? GIFT_CUTOFF_WARNING_TEXT : CUTOFF_WARNING_TEXT) : WARNING_TEXT}</strong>
    <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">לחצו כאן לשירות לקוחות</a>
  </div>
);

export { WARNING_TEXT, CUTOFF_WARNING_TEXT, GIFT_CUTOFF_WARNING_TEXT, WHATSAPP_TEXT, WHATSAPP_URL };
export default PurchasedScheduleUnavailableWarning;
